import React, { useEffect, useRef } from 'react'
import { useZionFormContext, FormPlaceSuggest } from '@fs/zion-form'
import { useAtSize } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

const placeFieldCss = css`
  & .autosuggest-wrapper {
    max-height: 72px;
  }
`

export default function PlaceField({
  name,
  type,
  orientation,
}: {
  name?: string
  type?: string
  orientation?: string
}): JSX.Element {
  const atSize = useAtSize()
  const [t] = useTranslation()
  const { setValue, getValues } = useZionFormContext()

  const isMobile = atSize({ default: true, md: false })
  const fullWidth = isMobile || orientation === 'vertical'
  const placeValues = getValues(name)?.place
  const placeLabel = fullWidth ? t('ancestors.place.condensed-label') : t(`ancestors.${type}.place.label`)
  const initialSelectedItem = placeValues?.primaryText
    ? { isStandard: getValues(name)?.place?.isStandard, primaryText: placeValues?.primaryText }
    : undefined
  const initialRenderRef = useRef(true)

  useEffect(() => {
    let cancelled = false
    if (!cancelled && initialRenderRef.current) {
      setValue(name, getValues(name) ?? { place: { primaryText: '' } })
      initialRenderRef.current = false
    }

    return () => {
      cancelled = true
    }
  }, [name, setValue, getValues])

  return (
    <div css={placeFieldCss}>
      <FormPlaceSuggest
        label={placeLabel}
        name={`${name}_place`}
        data-testid={`${name}-place`}
        initialSelectedItem={initialSelectedItem}
      />
    </div>
  )
}
